import { useParams } from "react-router-dom"

export const RedirectToPayment = () => {
    const {linkId} = useParams();
    window.fbq('track', 'AddToCart');
    setTimeout(() => {
        window.location.href = `https://buy.stripe.com/${linkId}`
    }, 300);
}